// extracted by mini-css-extract-plugin
export default {"bannerImg":"index_bannerImg_-MCOs"};